import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import sampleImage from "../assets/Blackwomen/BWI12.jpg"; // Consider replacing with an image showing an app dashboard or complex UI

const AccordionItem = ({ title, children, isOpen, onClick }) => (
  <div className="border-b border-gray-200">
    <button
      onClick={onClick}
      className="w-full text-left py-4 px-6 flex items-center justify-between bg-[#F3FAF9] hover:bg-[#e6f1f0] transition-colors"
    >
      <span className="uppercase text-sm tracking-wide text-gray-700">{title}</span>
      {isOpen ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
    </button>
    {isOpen && <div className="px-6 pb-4 text-gray-700 text-sm">{children}</div>}
  </div>
);

export default function BusinessGlowUp() {
  const [openIndex, setOpenIndex] = useState(0); // Default open: "What's Included"

  const toggleIndex = (index) => setOpenIndex((prev) => (prev === index ? null : index));

  return (
    <div className="max-w-6xl mx-auto mt-12 px-4 grid grid-cols-1 md:grid-cols-2 gap-10 items-start mb-20">

      {/* Left Side - Content & Accordion */}
      <div>
        <p className="uppercase text-sm text-[#c6884a] tracking-widest mb-2">Advanced Custom Web Application</p>
        <h1 className="text-4xl  text-gray-900 mb-4">The Business Glow-Up</h1>
        <p className="text-gray-700 mb-8">
          For growing women-owned businesses that need a custom web application to streamline operations, enhance user experience, and scale effectively.
        </p>

        <div className="border border-gray-200 rounded overflow-hidden shadow-sm">
          <AccordionItem
            title="What's Included"
            isOpen={openIndex === 0}
            onClick={() => toggleIndex(0)}
          >
            <ul className="list-disc list-inside space-y-1">
              <li>In-depth App Strategy & User Flow Mapping</li>
              <li>Robust Custom Web Application (8–10 key screens/modules) built with React, Tailwind, Firebase</li>
              <li>Dynamic Database Integration (Firestore) for complex data management (e.g., user profiles, content, transactions)</li>
              <li>Enhanced UI/UX Design tailored for conversion and engagement</li>
              <li>Content Management System (CMS) integration for easy updates (e.g., custom blog, resource library)</li>
              <li>Advanced SEO & Performance Optimization for app visibility</li>
              <li>Third-party API integration (e.g., payment gateways, scheduling tools)</li>
              <li>Automated email funnel integration (e.g., welcome sequences, notifications)</li>
              <li>Custom admin dashboard for managing app content/users</li>
              <li>Video training for app management + 30 days post-launch support</li>
            </ul>
          </AccordionItem>

          <AccordionItem
            title="Requirements/Not Included"
            isOpen={openIndex === 1}
            onClick={() => toggleIndex(1)}
          >
            <ul className="list-disc list-inside space-y-1">
              <li>Extensive custom backend logic beyond Firebase capabilities (e.g., dedicated Node.js server)</li>
              <li>Mobile native app development (iOS/Android)</li>
              <li>Ongoing advanced feature development after 30-day support window</li>
            </ul>
          </AccordionItem>

          <AccordionItem
            title="Timeline"
            isOpen={openIndex === 2}
            onClick={() => toggleIndex(2)}
          >
            <p>Estimated completion is 7–10 weeks, depending on scope complexity and client responsiveness.</p>
          </AccordionItem>

          <AccordionItem
            title="Project Investment"
            isOpen={openIndex === 3}
            onClick={() => toggleIndex(3)}
          >
            <p className="mb-3">Base Investment: $6,000 – $9,000</p>
            <ul className="list-disc list-inside space-y-1 mb-4">
              <li>30% non-refundable deposit due at time of signing contract</li>
              <li>35% due at the start of your project</li>
              <li>35% due 30 days after start date</li>
            </ul>
            <p className="font-semibold mt-4 mb-2">Available Add-Ons:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Custom analytics dashboard (+$1,500)</li>
              <li>Advanced user roles & permissions (+$1,000)</li>
              <li>Migration of existing data (quoted per scope)</li>
            </ul>
          </AccordionItem>
        </div>

        {/* CTA Section */}
        <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:gap-6 gap-3">
          <p className="text-gray-700 text-lg">
            <span className="italic">Investment begins at:</span>{' '}
            <span className="text-2xl text-gray-900  font-medium">$6,000</span>
          </p>
          <a href="/contact">
          <button className="bg-[#C18343] text-white uppercase tracking-widest px-6 py-3 text-sm hover:bg-[#a76e33] transition-colors">
            BOOK NOW
          </button>
          </a>
        </div>
      </div>

      {/* Right Side - Image */}
      <div className="w-full py-24">
        <img
          src={sampleImage}
          alt="Business web application preview"
          className="shadow-xl w-full h-[500px] object-cover"
        />
      </div>
    </div>
  );
}